import { render, staticRenderFns } from "./roundTurntable.vue?vue&type=template&id=c28b5396&scoped=true&"
import script from "./roundTurntable.vue?vue&type=script&lang=js&"
export * from "./roundTurntable.vue?vue&type=script&lang=js&"
import style0 from "./roundTurntable.vue?vue&type=style&index=0&id=c28b5396&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c28b5396",
  null
  
)

export default component.exports